// @ts-nocheck
import { useEffect, useState } from 'react';
import { Share, Plus, X, Smartphone } from 'lucide-react';

const LS_KEY = 'pwa-ios-banner-dismissed-at';
const DISMISS_DAYS = 3;

const isIos = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const isIOSDevice = /iPad|iPhone|iPod/.test(ua) && !('MSStream' in window);
  // iPadOS 13+ reporta como Mac; detecta pelo touch.
  const isIPadOS =
    navigator.platform === 'MacIntel' &&
    typeof navigator.maxTouchPoints === 'number' &&
    navigator.maxTouchPoints > 1;
  return isIOSDevice || isIPadOS;
};

const isStandalone = () => {
  if (typeof window === 'undefined') return false;
  // @ts-ignore
  if (window.navigator.standalone) return true; // Safari iOS
  return window.matchMedia('(display-mode: standalone)').matches;
};

/**
 * Banner superior fixo exibido SOMENTE se:
 *   - Dispositivo é iPhone/iPad
 *   - App não está instalado (não está em standalone)
 *   - Usuário ainda não dispensou há menos de 3 dias
 *
 * Instruções específicas do iOS porque push só funciona em PWA instalada
 * nesse sistema.
 */
export const InstallIosBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isIos()) return;
    if (isStandalone()) return;

    const lastDismiss = Number(localStorage.getItem(LS_KEY) || 0);
    if (lastDismiss && Date.now() - lastDismiss < DISMISS_DAYS * 24 * 60 * 60 * 1000) return;

    setVisible(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem(LS_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="bg-gradient-to-br from-primary to-primary/80 text-primary-foreground px-4 py-3 relative">
      <button
        onClick={dismiss}
        aria-label="Dispensar"
        className="absolute right-2 top-2 p-1.5 rounded-full hover:bg-white/10 transition"
      >
        <X className="h-4 w-4" />
      </button>
      <div className="flex items-start gap-3 pr-6">
        <div className="p-2 rounded-xl bg-white/15 shrink-0">
          <Smartphone className="h-5 w-5" />
        </div>
        <div className="text-sm leading-snug">
          <p className="font-semibold">
            Instale o app na tela inicial para receber notificações
          </p>
          <p className="text-xs opacity-90 mt-1 flex flex-wrap items-center gap-x-1">
            No Safari toque em
            <Share className="inline-block h-3.5 w-3.5 mx-1" />
            Compartilhar, depois
            <Plus className="inline-block h-3.5 w-3.5 mx-1" />
            <span className="whitespace-nowrap">“Adicionar à Tela de Início”.</span>
          </p>
        </div>
      </div>
    </div>
  );
};
